import React from 'react'
import {TextField as TextFieldUI, TextFieldProps} from 'wix-ui-tpa'
import classnames from 'classnames'
import {classes} from './text-field.st.css'

export const TextField: React.FC<TextFieldProps> = ({className, ...rest}) => (
  <TextFieldUI {...rest} className={classnames(classes.root, className)} />
)
